/**
 * @generated SignedSource<<5f748555546ea36eed9c0bdeff05a8be>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PackagesList_customer$data = {
  readonly activePackages: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"PackageItem_memberPackage">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly expiredPackages: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"PackageItem_memberPackage">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly upcomingPackages: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"PackageItem_memberPackage">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"PackagesListEmptyState_customer">;
  readonly " $fragmentType": "PackagesList_customer";
};
export type PackagesList_customer$key = {
  readonly " $data"?: PackagesList_customer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackagesList_customer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "type",
  "variableName": "packageType"
},
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "MemberPackageEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MemberPackage",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PackageItem_memberPackage"
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "packageType"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackagesList_customer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PackagesListEmptyState_customer"
    },
    {
      "alias": "activePackages",
      "args": [
        {
          "kind": "Literal",
          "name": "status",
          "value": "ACTIVE"
        },
        (v0/*: any*/)
      ],
      "concreteType": "MemberPackageConnection",
      "kind": "LinkedField",
      "name": "memberPackages",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": "upcomingPackages",
      "args": [
        {
          "kind": "Literal",
          "name": "status",
          "value": "UPCOMING"
        },
        (v0/*: any*/)
      ],
      "concreteType": "MemberPackageConnection",
      "kind": "LinkedField",
      "name": "memberPackages",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": "expiredPackages",
      "args": [
        {
          "kind": "Literal",
          "name": "status",
          "value": "EXPIRED"
        },
        (v0/*: any*/)
      ],
      "concreteType": "MemberPackageConnection",
      "kind": "LinkedField",
      "name": "memberPackages",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    }
  ],
  "type": "Customer",
  "abstractKey": null
};
})();

(node as any).hash = "a1f0f38d27812e7947c904a6a6ac0f16";

export default node;
